import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ProtectIcon extends BaseIcon {
  getChildren = () => [<path fill={ this.getColor() }
                             d='M651.648 670.848l-243.456 97.152h-48.384l-243.456-97.152-97.152-486.528 340.608-184.32h48.384l340.608 184.32zM403.2 115.2h-38.4l-249.6 107.52 71.808 396.672 177.792 71.808h38.4l178.944-71.808 70.656-396.672zM399.36 614.4h-28.416l-141.696-56.448-56.448-281.472 196.992-84.48h28.416l196.992 84.48-56.448 281.472zM395.52 230.4h-23.040l-161.28 69.12 46.080 230.4 115.2 46.080h23.040l115.2-46.080 46.080-230.4zM384 460.8c-31.811 0-57.6-25.789-57.6-57.6s25.789-57.6 57.6-57.6c31.811 0 57.6 25.789 57.6 57.6v0c0 31.811-25.789 57.6-57.6 57.6v0z'/>]
  getViewBox = () => '0 0 768 768'
}
